module.exports = __webpack_public_path__ + "static/img/po.ce35c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/about-us/po.png
// module id = zX0R
// module chunks = 1